module.exports = __webpack_public_path__ + "img/file-break.412f3152.svg";